import React from 'react';
import { Button, Space, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface OperatorLaunchButtonProps {
  className?: string;
  style?: React.CSSProperties;
}

const kbdStyle: React.CSSProperties = {
  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
  border: '1px solid #d1d5db',
  borderBottom: '2px solid #9ca3af',
  borderRadius: '3px',
  padding: '2px 4px',
  fontSize: '10px',
  fontWeight: 600,
  color: '#4b5563',
  minWidth: '16px',
  textAlign: 'center',
  boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
  lineHeight: '14px',
};

const OperatorLaunchButton: React.FC<OperatorLaunchButtonProps> = ({ className, style }) => {
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPod|iPad/i.test(navigator.platform);
  const modifierKey = isMac ? 'Option' : 'Alt';

  const handleLaunchOperator = () => {
    const event = new KeyboardEvent('keydown', {
      key: 'f',
      altKey: true,
      bubbles: true,
    });
    document.dispatchEvent(event);
  };

  return (
    <Button
      className={className}
      onClick={handleLaunchOperator}
      title={`Click to launch Operator or press ${modifierKey} + F`}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '280px',
        cursor: 'text',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        ...style,
      }}
    >
      {/* Left side: Icon + Text */}
      <Space size={8}>
        <SearchOutlined style={{ color: '#9ca3af', fontSize: '14px' }} />
        <Typography.Text type="secondary" style={{ fontSize: '14px' }}>
          Operator
        </Typography.Text>
      </Space>

      {/* Right side: Keyboard shortcut */}
      <Space size={1} style={{ position: 'relative', top: '-1px' }}>
        <span style={{ ...kbdStyle }}>{isMac ? '⌥' : 'Alt'}</span>
        <span style={kbdStyle}>F</span>
      </Space>
    </Button>
  );
};

export default OperatorLaunchButton;
